var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header-dark",attrs:{"id":"page-container"}},[_c('main-header'),_c('router-view'),_c('main-footer'),_c('staking'),_c('ledger-accounts'),(_vm.onlyErrorAlerts())?_c('alerts'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }